// Las herramientas que el agente recibe mientras el lienzo de un diseño está montado —
// el patrón del Estudio de Video (ADR-2026-09-11-el-director-del-estudio-se-funde-en-el-agente),
// aplicado al modo Diseño (ADR-2026-09-17-lanzar-es-el-unico-camino,
// ADR-2026-09-17-el-agente-opera-el-lienzo-del-diseno). Sin `ver_lienzo`: `ver_pantalla`
// ya trae el estado con cada celda, su rol y su id.

import type { HerramientaDePantalla } from '../../../../chat-atlas/puenteDePantalla';

export const CLAVE_PANTALLA_DISENO = 'diseno-indumentaria';
export const SKILL_DE_DISENO = 'diseno-de-indumentaria';

const CELDA = {
  type: 'string',
  description: 'El id de la celda del lienzo (lo lista ver_pantalla: id y título de cada imagen).',
};
const INSTRUCCION = {
  type: 'string',
  description: 'Instrucción adicional del diseñador, en castellano, hasta 800 caracteres. Opcional.',
};
const CANTIDAD = {
  type: 'integer',
  minimum: 1,
  maximum: 6, // = MAX_CANTIDAD (asistente/directMode.ts); literal acá para no meter un import de la app en este archivo de tools.
  description: 'Cuántas imágenes generar, de 1 a 6. Opcional: por defecto 4 (en uso) o 2 (mezcla). 1 crédito por imagen.',
};

export const HERRAMIENTAS_DE_DISENO: HerramientaDePantalla[] = [
  {
    name: 'mostrar_en_uso',
    etiqueta: 'Mostrando la prenda en uso…',
    description:
      'Genera fotos (4 por defecto) de una persona real usando la prenda de esa celda. Atlas mira la prenda y escribe un prompt DISTINTO por foto (escena, plano y pose diferentes) con las buenas prácticas de foto con modelo; la instrucción adicional, si la hay, se aplica a todas (quién la usa, dónde, con qué). 1 crédito por imagen; tardan un poco más que otras acciones (primero se escriben los prompts) y caen debajo de la prenda en el lienzo. Confirmá con el usuario antes si no lo pidió explícitamente.',
    input_schema: { type: 'object', properties: { celda_id: CELDA, instruccion: INSTRUCCION, cantidad: CANTIDAD }, required: ['celda_id'] },
  },
  {
    name: 'mezclar',
    etiqueta: 'Armando la mezcla…',
    description:
      'Arma (y por defecto genera) una MEZCLA sobre la imagen de celda_id: cada parte es otra celda del lienzo (una textura, una inspiración, otra prenda, la foto de una persona) con qué tomar de ella ("el estampado", "el color", "la silueta", "la persona que la usa y su escena"). Hasta 9 partes. El resultado puede ser cualquier cosa —una prenda nueva, la persona de otra foto usando la base, una escena—: Atlas mira las imágenes con lo que se pidió de cada una y escribe el prompt; vos no lo escribís. `resultado` dice qué tipo de imagen sale: "realista" (default: una prenda o foto real, aunque la base sea un plano técnico) o "como_la_base" (un plano se edita como plano). Con generar=false sólo queda armada en pantalla (anillo, líneas y cajitas) para que el usuario la revise y la genere; no se guarda. Genera 2 imágenes por defecto, 1 crédito cada una; caen debajo de la prenda.',
    input_schema: {
      type: 'object',
      properties: {
        celda_id: CELDA,
        partes: {
          type: 'array',
          description: 'Las partes de la mezcla, en orden.',
          maxItems: 9, // = MAX_PARTES (promptsDeDiseno.ts); literal acá para no meter un import de la app en este archivo de tools.
          items: {
            type: 'object',
            properties: { celda_id: CELDA, instruccion: { type: 'string', description: 'Qué tomar de esa imagen.' } },
            required: ['celda_id', 'instruccion'],
          },
        },
        instruccion: { type: 'string', description: 'Instrucción general de la mezcla. Opcional.' },
        resultado: {
          type: 'string',
          enum: ['realista', 'como_la_base'],
          description: 'Qué tipo de imagen sale. "realista" (default): una prenda o foto real, aunque la base sea un plano técnico. "como_la_base": del mismo tipo que la base (un plano se edita como plano).',
        },
        cantidad: CANTIDAD,
        generar: { type: 'boolean', description: 'Default true. Con false sólo se arma la mezcla en pantalla, sin gastar créditos.' },
      },
      required: ['celda_id', 'partes'],
    },
  },
  {
    name: 'plano_tecnico',
    etiqueta: 'Dibujando el plano técnico…',
    description:
      'Genera el plano técnico (flat sketch: frente y espalda en línea sobre blanco) de la imagen de esa celda, sea la que sea. Cuesta 1 crédito; cae debajo de la imagen.',
    input_schema: { type: 'object', properties: { celda_id: CELDA }, required: ['celda_id'] },
  },
];

export const NOMBRES_HERRAMIENTAS_DE_DISENO: string[] = HERRAMIENTAS_DE_DISENO.map((h) => h.name);
